import { Component } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import es from "date-fns/locale/es"; // the locale you want
import ParametroIngresoSolicitud from "../../../Contenedores/Padron/ParametroIngresoSolicitud";
import ServicioSolicitudPadron from "../../../servicios/SolicitudDePadron";
import { TIPO_SOLICITUD_MODIFICACION } from "../../../Contenedores/Comun/VARIABLES";
import { CerrarNotificador, Notificar } from "../../Comunes/Notificador";
import InputMask from "react-input-mask";
import {
  __MaximoCaracteresIdentificacion,
  __ObtengaClasePersona,
} from "../../../Utils/Funciones";
import { ObtengaPersonaUnificada } from "../../../servicios/Padron";
import Identificacion from "../../../Contenedores/Comun/Identificacion";
import TipoPersona from "../../../Contenedores/Comun/TipoPersona";
import DocumentosSolicitud from "../../Comunes/Documentos/DocumentosSolicitud";
import IdentificacionesAsociadas from "../../Comunes/IdentificacionesAsociadas/IdentificacionesAsociadas";
import TipoPersonaDropdown from "../../Comunes/Dropdowns/TiposPersona/TipoPersonaDropdown";
import PaisesDropdown from "../../Comunes/Dropdowns/Paises/PaisesDropdown";
import GenerosDropdown from "../../Comunes/Dropdowns/Generos/GenerosDropdown";
import StickyTopBox from "../../Comunes/StickyBox/StickyTopBox";
import TextareaAutoajustable from "../../Comunes/TextareaAutoajustable/TextareaAutoajustable";
import NotaEliminacionAcentos from "../Comunes/NotaEliminacionAcentos";
registerLocale("es", es);

export class Modificacion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Archivos: [],
      identificacion: "",
      seleccionTipoPersona: "1",
      seleccionGenero: 0,
      seleccionPais: "0",
      fechaNacimiento: null,
      primerApellido: "",
      segundoApellido: "",
      nombreORazonSocial: "",
      TipoPersonaFisica: true,
      MaximoCaracteres: 9,
      MostrarInformacion: false,
    };

    this._onSelectGenero = this._onSelectGenero.bind(this);
    this._onSelectPais = this._onSelectPais.bind(this);
    this._fechaSeleccionada = this._fechaSeleccionada.bind(this);
    this._onSelectTiposPersona = this._onSelectTiposPersona.bind(this);
    this._ObtengaIdentificacion = this._ObtengaIdentificacion.bind(this);
    this._buscarPersona = this._buscarPersona.bind(this);
    this._guardarModificacion = this._guardarModificacion.bind(this);
  }

  async ReiniciarEstados() {
    this.setState({
      identificacion: "",
      Archivos: [],
      seleccionTipoPersona: "1",
      seleccionGenero: 0,
      seleccionPais: "0",
      fechaNacimiento: null,
      primerApellido: "",
      segundoApellido: "",
      nombreORazonSocial: "",
      TipoPersonaFisica: true,
      MaximoCaracteres: 9,
      identificacionesAsociadas: [],
      MostrarInformacion: false,
    });

    this.limpiarDocumentos();
  }

  async _onSelectTiposPersona(e) {
    let valor = e.target.value;
    let max = await __MaximoCaracteresIdentificacion(valor);
    let TipoPersonaFisica = __ObtengaClasePersona(valor) === "F";
    this.setState({
      MaximoCaracteres: max,
      MostrarInformacion: false,
      TipoPersonaFisica: TipoPersonaFisica,
      seleccionTipoPersona: valor,
    });
  }

  async _onSelectPais(e) {
    this.setState({
      seleccionPais: e.target.value,
    });
  }

  async _onSelectGenero(e) {
    this.setState({
      seleccionGenero: e.target.value,
    });
  }

  async _fechaSeleccionada(date) {
    this.setState({
      fechaNacimiento: date,
    });
  }
  async _ObtengaIdentificacion({ target: { value } }) {
    value = value.replace(/\s/g, '');

    this.setState({
      identificacion: value,
      MostrarInformacion: false,
    });
  }

  async maskbuilder(v) {
    let digitos = !v ? "" : v.replace(/[^\d]/g, "");
    if (digitos.length > this.state.MaximoCaracteres) {
      digitos = v.substring(0, this.state.MaximoCaracteres);
      this.setState({ identificacion: digitos });
    }
    return digitos;
  }

  async CargarInformacion(datos) {
    document.getElementById("NombreORazonSocial").value =
      datos.nombreORazonSocial;
    document.getElementById("PrimerApellido").value = datos.primerApellido;
    document.getElementById("SegundoApellido").value = datos.segundoApellido;
    let identificaciones =
      datos.identificacionesAsociadas.length > 0
        ? datos.identificacionesAsociadas
        : null;

    this.setState({
      MostrarInformacion: true,
      identificacion: datos.identificacionPrincipal.codigo,
      seleccionGenero: datos.genero,
      seleccionTipoPersona: datos.identificacionPrincipal.tipoPersona.codigo,
      seleccionPais: datos.paisRegistroONacimiento?.codigoPais ?? "0",
      fechaNacimiento:
        datos.fechaConstitucionONacimiento != null
          ? new Date(datos.fechaConstitucionONacimiento)
          : null,
      primerApellido: datos.primerApellido,
      segundoApellido: datos.segundoApellido,
      nombreORazonSocial: datos.nombreORazonSocial,
      identificacionesAsociadas: identificaciones,
    });
  }

  async _buscarPersona() {
    let parametro = new Identificacion();
    parametro.Codigo = document.getElementById("Identificacion").value;
    parametro.TipoPersona = new TipoPersona();
    parametro.TipoPersona.Codigo = this.state.seleccionTipoPersona;
    let consulta = await ObtengaPersonaUnificada(parametro);
    if (consulta.esValido) {
      await this.CargarInformacion(consulta);
      CerrarNotificador();
    } else {
      Notificar("error", consulta.errores);
    }
  }

  async _guardarModificacion() {
    let parametro = new ParametroIngresoSolicitud();
    let segundoApellido = document.getElementById("SegundoApellido").value;
    parametro.IdentificacionPersona =
      document.getElementById("Identificacion").value;
    parametro.TipoPersona = this.state.seleccionTipoPersona;
    parametro.NombreORazonSocial =
      document.getElementById("NombreORazonSocial").value;
    if (this.state.TipoPersonaFisica) {
      parametro.PrimerApellido =
        document.getElementById("PrimerApellido").value;
      parametro.SegundoApellido =
        segundoApellido === "" ? null : segundoApellido;
      parametro.Genero = this.state.seleccionGenero;
    }
    parametro.FechaConstitucionONacimiento = this.state.fechaNacimiento;
    parametro.PaisRegistroONacimiento =
      this.state.seleccionPais === "0" ? null : this.state.seleccionPais;
    parametro.TipoSolicitud = TIPO_SOLICITUD_MODIFICACION;
    parametro.ListaDocumentos = this.state.Archivos;
    parametro.FechaTramite = new Date();
    var ingresarModificacion =
      await ServicioSolicitudPadron.IngresarSolicitudDePadron(parametro);

    if (ingresarModificacion.esValido) {
      await this.ReiniciarEstados();
      Notificar("success", ingresarModificacion.mensaje);
    } else {
      Notificar("error", ingresarModificacion.errores);
    }
  }

  obtenerDocumentos = (documentos) => {
    this.setState({ Archivos: documentos });
  };

  limpiarDocumentos = () => {};

  asignarFuncionLimpiarDocumentos = (funcionLimpiarDocumentos) => {
    this.limpiarDocumentos = funcionLimpiarDocumentos;
  };

  render() {
    return (
      <div>
        <StickyTopBox>
          <div className="row">
            <div className="col">
              <h1 className="h3 mb-0 text-gray-800">
                Solicitud de modificación al padrón
              </h1>
            </div>

            {this.state.MostrarInformacion === true ? (
              <div className="col text-right">
                <button
                  onClick={this._guardarModificacion}
                  className="btn btn-success btn-icon-split mr-3"
                >
                  <span className="icon text-white-50">
                    <i className="far fa-check-circle"></i>
                  </span>
                  <span className="text">Guardar solicitud</span>
                </button>
              </div>
            ) : null}
          </div>
        </StickyTopBox>

        <div className="card shadow mb-4">
          <div className="card-header">
            <h6 className="m-0 font-weight-bold text-primary">
              Identificación
            </h6>
          </div>
          <div className="card-body">
            <div className="form-group row">
              <div className="col-md-3 col-form-label">
                <label htmlFor="TiposPersona"> Tipo Persona</label>
              </div>
              <div className="col-md-9">
                <TipoPersonaDropdown
                  id="TiposPersona"
                  className="form-control"
                  value={this.state.seleccionTipoPersona}
                  onChange={(e) => this._onSelectTiposPersona(e)}
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-md-3">
                <label htmlFor="Identificacion" className="col-form-label">
                  Identificación
                </label>
              </div>
              <div className="col-md-9">
                <InputMask
                  mask={this.maskbuilder(this.state.identificacion)}
                  maskChar=""
                  value={this.state.identificacion}
                  id="Identificacion"
                  className="form-control"
                  style={{
                    textTransform: "uppercase",
                  }}
                  onChange={this._ObtengaIdentificacion}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <button
                  id="btnBuscarAutorizaciones"
                  onClick={this._buscarPersona}
                  type="button"
                  className="btn btn-large btn-primary btn-icon-split"
                >
                  <span className="icon text-white-50">
                    <i className="fas fa-search"></i>
                  </span>
                  <span className="text">Buscar</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: this.state.MostrarInformacion ? "" : "none" }}>
          <div className="card shadow mb-4">
            <div className="card-header">
              <h6 className="m-0 font-weight-bold text-primary">
                Datos de la Persona
              </h6>
            </div>
            <div className="card-body">
              <div className="form-group row">
                <div className="col-md-3">
                  <label
                    htmlFor="NombreORazonSocial"
                    className="col-form-label"
                  >
                    {this.state.TipoPersonaFisica ? "Nombre" : "Razón Social"}
                  </label>
                </div>
                <div className="col-md-9">
                  <TextareaAutoajustable
                    className="form-control"
                    id="NombreORazonSocial"
                    defaultValue={this.state.nombreORazonSocial}
                    style={{
                      textTransform: "uppercase",
                    }}
                    maxLength={255}
                  />
                  <NotaEliminacionAcentos/>
                </div>
              </div>

              <div
                className="form-group row"
                style={{
                  display: this.state.TipoPersonaFisica ? "" : "none",
                }}
              >
                <div className="col-md-3">
                  <label htmlFor="PrimerApellido" className="col-form-label">
                    Primer Apellido
                  </label>
                </div>
                <div className="col-md-9">
                  <input
                    type="text"
                    className="form-control"
                    id="PrimerApellido"
                    defaultValue={this.state.primerApellido}
                    style={{ textTransform: "uppercase" }}
                  />
                  <NotaEliminacionAcentos/>
                </div>
              </div>

              <div
                className="form-group row"
                style={{
                  display: this.state.TipoPersonaFisica ? "" : "none",
                }}
              >
                <div className="col-md-3">
                  <label htmlFor="SegundoApellido" className="col-form-label">
                    Segundo Apellido
                  </label>
                </div>
                <div className="col-md-9">
                  <input
                    type="text"
                    className="form-control"
                    id="SegundoApellido"
                    defaultValue={this.state.segundoApellido}
                    style={{ textTransform: "uppercase" }}
                  />
                  <NotaEliminacionAcentos/>
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-3">
                  <label
                    htmlFor="FechaConstitucionONacimiento"
                    className="col-form-label"
                  >
                    Fecha{" "}
                    {this.state.TipoPersonaFisica
                      ? "Nacimiento"
                      : "Constitución"}
                  </label>
                </div>
                <div className="col-md-9">
                  <DatePicker
                    id="FechaConstitucionONacimiento"
                    locale="es"
                    selected={this.state.fechaNacimiento}
                    onChange={this._fechaSeleccionada}
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                  />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-3">
                  <label htmlFor="Pais" className="col-form-label">
                    País de{" "}
                    {this.state.TipoPersonaFisica
                      ? "Nacimiento"
                      : "Constitución"}
                  </label>
                </div>
                <div className="col-md-9">
                  <PaisesDropdown
                    id="Pais"
                    className="form-control"
                    value={this.state.seleccionPais}
                    onChange={(e) => this._onSelectPais(e)}
                  />
                </div>
              </div>

              <div
                className="form-group row"
                style={{
                  display: this.state.TipoPersonaFisica ? "" : "none",
                }}
              >
                <div className="col-md-3">
                  <label htmlFor="Genero" className="col-form-label">
                    Género
                  </label>
                </div>
                <div className="col-md-9">
                  <GenerosDropdown
                    id="Genero"
                    className="form-control"
                    value={this.state.seleccionGenero}
                    onChange={(e) => this._onSelectGenero(e)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div>
            {this.state.identificacionesAsociadas != null ? (
              <IdentificacionesAsociadas
                Titulo="Identificaciones Asociadas"
                Identificaciones={this.state.identificacionesAsociadas}
              />
            ) : null}
          </div>
          <div>
            <DocumentosSolicitud
              onChangeDocumentos={this.obtenerDocumentos}
              pasarFuncionLimpiarState={this.asignarFuncionLimpiarDocumentos}
            />
          </div>
        </div>
      </div>
    );
  }
}
